import React, { Component, Fragment } from "react"
import styled, { css } from "react-emotion"
import { Button, ButtonGroup, Heading, Section, Text } from "ui"

import { getList } from "features/editor/blockTypes"
import Draggable from "features/editor/dnd/Draggable"
import BroadcastContext from "./broadcast/Context"
import DisplayBroadcast from "./broadcast/DisplayBroadcast"
import withContext from "./withContext"

import { groupBy } from "lodash"
import Checkbox from "ui/legacy/Checkbox"

import { ThemeProvider } from "emotion-theming"
import stackerDarkTheme from "ui/styleHelpers/stackerDarkTheme"

const onlyOneChild = css`
    & > div {
        display: none;
    }
    & > div:first-child {
        display: block;
    }
`

const sidebarclasses = css`
    width: 100%;
    height: 100%;
    max-height: 100%;
    display: flex;
    flex-direction: column;
    // background: #f1f1f1;
    // box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.15);
    padding: 5px;
    margin-right: 10px;
    color: #eee;
    overflow: auto;
    .sidebar-divider {
        margin-top: 25px;
    }
    li {
        margin: 2px 0;
    }

    & * {
        color: #eee;
    }
`

const classNames = {
    warning: css`
        background: #fcc;
        color: red;
        padding: 5px;
    `,
}

class Sidebar extends Component {
    blocks = getList()
    state = {
        open: true,
        selectedPane: "styles",
    }
    render() {
        return (
            <BroadcastContext>
                {({ allItems }) => {
                    const validation = allItems.filter(({ channel }) => channel === "validation")
                    const { error, warning } = groupBy(validation, "severity")

                    return (
                        <ThemeProvider theme={stackerDarkTheme}>
                            <div className={sidebarclasses}>
                                <ButtonGroup className="display-flex">
                                    <Button
                                        color={
                                            this.state.selectedPane === "attributes"
                                                ? "success"
                                                : "primary"
                                        }
                                        className="flex-1"
                                        size="small"
                                        active={this.state.selectedPane === "attributes"}
                                        onClick={() =>
                                            this.setState({
                                                selectedPane: "attributes",
                                            })
                                        }
                                        icon="cog"
                                    />
                                    <Button
                                        color={
                                            this.state.selectedPane === "styles"
                                                ? "success"
                                                : "primary"
                                        }
                                        className="flex-1"
                                        size="small"
                                        onClick={() =>
                                            this.setState({
                                                selectedPane: "styles",
                                            })
                                        }
                                        icon="paint-brush"
                                    />
                                    <Button
                                        color={
                                            this.state.selectedPane === "behaviour"
                                                ? "success"
                                                : "primary"
                                        }
                                        className="flex-1"
                                        size="small"
                                        active={this.state.selectedPane === "behaviour"}
                                        onClick={() =>
                                            this.setState({
                                                selectedPane: "behaviour",
                                            })
                                        }
                                        icon="bolt"
                                    />
                                    {/* <Button
                                    type="primary"
                                    className="flex-1"
                                    size="small"
                                    active={this.state.selectedPane === "debug"}
                                    onClick={() => this.setState({ selectedPane: "debug" })}
                                >
                                    Debug
                                </Button>
                                <Button
                                    type="primary"
                                    size="small"
                                    className="flex-1"
                                    active={this.state.selectedPane === "blocks"}
                                    onClick={() => this.setState({ selectedPane: "blocks" })}
                                >
                                    Add Blocks
                                </Button> */}
                                    {/* <Button
                                    type={error ? "danger" : warning ? "warning" : "primary"}
                                    size="small"
                                    className="flex-1"
                                    active={this.state.selectedPane === "validation"}
                                    onClick={() => this.setState({ selectedPane: "validation" })}
                                >
                                    Editor Config
                                </Button> */}
                                </ButtonGroup>
                                <div className="sidebar-divider" />
                                <SidebarSection
                                    margin="none"
                                    style={{
                                        display:
                                            this.state.selectedPane === "attributes"
                                                ? "block"
                                                : "none",
                                    }}
                                >
                                    {/* <Heading size="small" light>
                                        Attributes
                                    </Heading> */}
                                    <div id="attributes" className={onlyOneChild} />

                                    <div style={{ display: "none" }}>
                                        <div className="sidebar-divider" />
                                        <Heading size="small" light>
                                            Properties
                                        </Heading>
                                        <div id="properties" className={onlyOneChild} />
                                        <div className="sidebar-divider" />
                                        <Heading size="small" light>
                                            Actions
                                        </Heading>
                                        <div id="actions" />
                                        <div className="sidebar-divider" />
                                        <Heading size="small" light>
                                            Validation
                                        </Heading>
                                        <div id="validation" className={onlyOneChild} />
                                    </div>
                                </SidebarSection>
                                <SidebarSection
                                    margin="none"
                                    padding="none"
                                    style={{
                                        display:
                                            this.state.selectedPane === "behaviour"
                                                ? "block"
                                                : "none",
                                    }}
                                >
                                    {/* <Heading size="small" light>
                                        Attributes
                                    </Heading> */}
                                    <div id="blockActions" className={onlyOneChild} />
                                </SidebarSection>
                                <SidebarSection
                                    margin="none"
                                    padding="none"
                                    style={{
                                        display:
                                            this.state.selectedPane === "styles" ? "block" : "none",
                                    }}
                                >
                                    <div id="blockActions" className={onlyOneChild} />
                                    {/* <Heading size="small" light>
                                        Attributes
                                    </Heading> */}
                                    <div id="styles" className={onlyOneChild} />
                                    <div style={{ display: "none" }}>
                                        <div className="sidebar-divider" />
                                        <Heading size="small" light>
                                            Properties
                                        </Heading>
                                        <div id="properties" />
                                        <div className="sidebar-divider" />
                                        <Heading size="small" light>
                                            Actions
                                        </Heading>
                                        <div id="actions" />
                                        <div className="sidebar-divider" />
                                        <Heading size="small" light>
                                            Validation
                                        </Heading>
                                        <div id="validation" />
                                    </div>
                                </SidebarSection>
                                <div
                                    style={{
                                        display:
                                            this.state.selectedPane === "debug" ? "block" : "none",
                                    }}
                                    id="debug"
                                />
                                <div
                                    id="Blocks"
                                    style={{
                                        display:
                                            this.state.selectedPane === "blocks" ? "block" : "none",
                                    }}
                                >
                                    {this.blocks.map(({ name, blocks }) => (
                                        <Fragment key={name}>
                                            <h3>{name}</h3>
                                            {blocks.map(
                                                (
                                                    { label, blockElement, id, defaultConfig },
                                                    index
                                                ) => (
                                                    <Draggable
                                                        key={index}
                                                        payload={{
                                                            blockElement,
                                                            defaultConfig,
                                                            id,
                                                        }}
                                                        onDrop={() =>
                                                            this.setState({
                                                                selectedPane: "attributes",
                                                            })
                                                        }
                                                    >
                                                        {({ getRootProps, dnd }) => (
                                                            <Text {...getRootProps()}>{label}</Text>
                                                        )}
                                                    </Draggable>
                                                )
                                            )}
                                        </Fragment>
                                    ))}
                                </div>
                                <div
                                    id="globalvalidation"
                                    style={{
                                        display:
                                            this.state.selectedPane === "validation"
                                                ? "block"
                                                : "none",
                                    }}
                                >
                                    <label>
                                        User can Edit?
                                        <Checkbox
                                            value={this.props.context.editor.isEditing}
                                            onChange={event =>
                                                this.props.setIsEditing(event.target.checked)
                                            }
                                        />{" "}
                                    </label>
                                    <div className="sidebar-divider" />
                                    <div>
                                        <Heading size="small" light>
                                            Errors, warnings
                                        </Heading>{" "}
                                        {!validation.length && <em>(none)</em>}
                                        <div onClick={event => event.stopPropagation()}>
                                            {validation.map(broadcast => (
                                                <Fragment>
                                                    <div className={classNames[broadcast.severity]}>
                                                        {broadcast.description}
                                                        <DisplayBroadcast
                                                            small
                                                            broadcast={broadcast.payload.target}
                                                        />
                                                    </div>
                                                    <div>
                                                        <DisplayBroadcast
                                                            small
                                                            broadcast={broadcast}
                                                        />
                                                    </div>
                                                </Fragment>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ThemeProvider>
                    )
                }}
            </BroadcastContext>
        )
    }
}

Sidebar.propTypes = {}

export default withContext(Sidebar)

const SidebarSection = styled(Section)`
    overflow: scroll;
    height: 100%;
    max-height: 100%;
`



// WEBPACK FOOTER //
// ./src/features/editor/Sidebar.js